import { createSlice } from "@reduxjs/toolkit";
import { Toastify } from "../../../../components/Toaster";
import { errorSideEffects, loadingSideEffects, successSideEffects, updatingSideEffects } from "../..";
import { getOutcomeTrackingState, getRequestTrackingState, MutationTrackingState } from "../../../../services/analytics/tracking";

export interface GoogleAuthenticator {
  AccountSecretKey?: string;
  QRCodeWidth?: number;
  IsEnabled?: boolean;
  IssuerId?: string;
  errorCode?: string;
  description?: string;
}

export interface GoogleAuthenticatorState {
  Data: GoogleAuthenticator;
  isLoading: boolean;
  isUpdating: boolean;
  isSuccess: boolean;
  isError: boolean;
  errorMessage: string | null;
}

export const GoogleAuthenticator = createSlice({
  name: "googleAuthenticator",
  initialState: {
    Data: {},
    isLoading: false,
    isUpdating: false,
    isSuccess: false,
    isError: false,
    errorMessage: null
  },
  reducers: {
    getGoogleAuthenticator(state) {
      Object.assign(state, loadingSideEffects);
    },
    getGoogleAuthenticatorSuccess(state, action) {
      state.Data = action.payload;
      Object.assign(state, successSideEffects);
    },
    getGoogleAuthenticatorError(state, action) {
      Object.assign(state, errorSideEffects);
      state.errorMessage = action.payload;
    },
    updateGoogleAuthenticator(state, action) {
      Object.assign(state, updatingSideEffects, getRequestTrackingState(action));
    },
    updateGoogleAuthenticatorSuccess(state, action) {
      Object.assign(state, successSideEffects, getOutcomeTrackingState(state as MutationTrackingState, "success"));
      state.Data = action.payload;
      Toastify("success", "TOTP updated successfully");
    },
    updateGoogleAuthenticatorError(state, action) {
      Object.assign(state, errorSideEffects, getOutcomeTrackingState(state as MutationTrackingState, "error"));
      state.errorMessage = action.payload;
      Toastify("error", action.payload);
    }
  }
});

export const { getGoogleAuthenticator, getGoogleAuthenticatorError, getGoogleAuthenticatorSuccess, updateGoogleAuthenticator, updateGoogleAuthenticatorError, updateGoogleAuthenticatorSuccess } =
  GoogleAuthenticator.actions;

export default GoogleAuthenticator.reducer;
